












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoadingIndicator extends Vue {
  @Prop({required: false, default: false, type: Boolean})
  public minimal!: boolean;
}
